import { RootState } from 'store';

export const transactionData = (state: RootState) => state.transactionData;
